export default "__VITE_ASSET__lLJp3Ehs__"